import { Transforms, Editor } from 'slate'
import { Registry } from '@react-registry'
import React from 'react'

import { defaultTable } from './defaultTable'
import { elementCategories } from '../../elementCategories'

import { InsertTable } from './CustomTableIcon/insertTable'
import { useSlate } from 'slate-react'

import { disableOnCodeChild } from '../../code/utils'
import { TableCreateIcon } from '../../../utils/Icon'
import { ElementWithType } from '../../../../../../../utils/types'

const cellType = ['td', 'th']
export const addTable = (event, { editor }) => {
  const { selection } = editor

  const tableAttributes = defaultTable(2, 2)
  if (selection && selection.focus.path) {
    const { path } = selection.focus
    Transforms.insertNodes(editor, tableAttributes)
    let paragraphPath = path.slice(0, path.length - 1)
    paragraphPath[paragraphPath.length - 1] = paragraphPath[paragraphPath.length - 1] + 2
    let tablePath = paragraphPath.slice()
    tablePath[tablePath.length - 1] = tablePath[tablePath.length - 1] - 1
    tablePath = [...tablePath, 0, 0, 0, 0]
    Transforms.select(editor, tablePath)
    Transforms.insertNodes(
      editor,
      {
        type: 'p',
        attrs: {},
        children: [{ text: '' }]
      } as ElementWithType,
      { at: [...paragraphPath] }
    )
  }
  return
}

const CreateTableButton = (props) => {
  const editor = useSlate()
  return (
    <React.Fragment>
      {props.children({
        handleMouseDown: addTable,
        isDisable: { func: disableOnCodeChild, params: { editor } },
        CustomIcon: InsertTable,
        additionalParams: { editor }
      })}
    </React.Fragment>
  )
}

const shortcutAddTable = (event, editor, format, registryObj) => {
  addTable(event, { editor })
}

Registry.register(
  {
    IngressComponent: CreateTableButton,
    category: elementCategories.TABLE_ACTION,
    iconName: <TableCreateIcon />,
    title: 'Insert table',
    shortcut: { key: 'mod+alt+shift+t', callback: shortcutAddTable },
    toolbar: {
      inSlashToolbar: false
    },
    canCustomize: false,
    inBasicToolbar: false,
    isContentStackElement: true
  },
  {
    id: 'table-create-table',
    registry: 'element'
  }
)
